import React,{Component} from 'react';
import Button from '@react/react-spectrum/Button';
import ModalTrigger from '@react/react-spectrum/ModalTrigger';
import {withTranslation } from 'react-i18next';
import CustomApproveDialog from './CustomApproveDialog';
import {connect} from "react-redux";
import {approveRequest} from '../../actions/ApproveRejectActions';
import { extractDetails } from '../../services/approval-util';

export class ApproveModal extends Component{
    constructor(props){
        super(props);
        this.state = {
            disableConfirmBtn:true,
            orderId: extractDetails(this.props.approvedData,"id"),
        };
        this.confirm = this.confirm.bind(this);
    }

    confirm(){
        this.props.approveRequest(this.props.approveId);
    }


    render(){
        return(
            <ModalTrigger>
                <Button label={this.props.btnLabel} variant={this.props.variant} modalTrigger  data-am-id="approveModalBtn" data-approval-id={this.props.approveId}/>
                <CustomApproveDialog 
                type={this.props.workFlowType} 
                approvalMetaData={this.props.approvalMetaData} 
                confirm={this.confirm} 
                getStandardGoUrls={this.props.getStandardGoUrls} 
                locale={this.props.locale} 
                backdropClickable 
                totalLicense={this.props.totalLicenses}
                approvalData={this.props.approvedData}
                />
            </ModalTrigger>
        )
    }
}

const mapStateToProps = (state)=>{
    return{
        showSuccessMsg:state.ToastReducer.showSuccessToast,
        userAccessToken:state.AuthReducer.userAccessToken,
        userDetails:state.AuthReducer.userInfo,
        locale:state.LocaleReducer.goUrlLocale,
        getStandardGoUrls:state.AppReducer.getStandardGoUrls
    }
};


const mapDispatchToProps = (dispatch)=>{
    return{
        approveRequest:(approvalID)=>{dispatch(approveRequest(approvalID))}
    }
};

export default connect(mapStateToProps,mapDispatchToProps)(withTranslation()(ApproveModal));

